import React from 'react';

import TooltipIcon, { TooltipIconProps } from 'common/controls/items/TooltipIcon';

const TooltipWarning: React.FC<TooltipIconProps> = (props) => <TooltipIcon iconName="Warning" {...props} />;

export default TooltipWarning;
